<template>
	<div id="modalgmo">
		<div class="modalcontent">
			<div class="description">
				<div>{{contentsName}}</div>
				<div>{{contentsMoney}}</div>
			</div>
			<div class="subPayment paymentCredit" style="display: block;">
				<GmoInput></GmoInput>
			</div>
			
			<div v-if="enablePoint" class="ufpoint">
				<div class="row">
					<label class="col-xs-7 col-form-label">利用ポイント<br />({{textMoneyUfPoint}}円利用可能)</label>
					<div class="col-xs-5">
						<input type="text" value="" class="form-control" v-model="usePoint">
					</div>
				</div>
				<div class="row">
					<label class="col-xs-7 col-form-label">支払い合計</label>
					<div class="col-xs-5 text-right">{{textPaymentMoney}}円</div>
				</div>
				<div class="row">
					<label class="col-xs-7 col-form-label">獲得ポイント</label>
					<div class="col-xs-5 text-right">{{textGetPoint}}pt</div>
				</div>
			</div>
			<div class="cmd">
				<div class="one"><button class="btn btn-default" @click.prevent="clickClose">キャンセル</div>
				<div class="one"><button class="btn btn-primary" @click.prevent="clickBuy">購入する</div>
			</div>
		</div>
	</div>
</template>

<script>
	import GmoInput from '@/components/GmoInput';
	import {addFigure} from '@/lib/formatter';

	export default {
		components: {
			GmoInput
		},
		props: {
			// 商品名
			contentsName: { type: String, required: true },
			// 金額
			contentsMoney: { type: String, required: true },
			valMoney: { type: Number, required: true },
			// UFポイント利用可
			enablePoint: { type: Boolean, required: true }
		},
		data() {
			return {
				usePoint: '',
				
				// 利用ポイント下１桁0調整用タイマー
				tidCeilUsePoint: null,
			}
		},
		computed: {
			ufPoint() {
				return this.$store.getters['commonStore/getUfPoint'];
			},
			pointUfPoint() {
				if(!this.ufPoint) return 0;
				if(!this.ufPoint.point) return 0;
				return this.ufPoint.point;
			},
			textMoneyUfPoint() {
				if(!this.pointUfPoint) return '0';
				return addFigure(this.pointUfPoint);
			},
			paymentMoney() {
				if(this.usePoint > 0) {
					return Math.max(0, this.valMoney-this.usePoint);
				}
				return this.valMoney;
			},
			textPaymentMoney() {
				return addFigure(this.paymentMoney);
			},
			textGetPoint() {
				const point = Math.floor(this.paymentMoney*0.005);
				return addFigure(point);
			},
		},
		watch: {
			usePoint(val) {
				if(val !== '') {
					if(isNaN(val)) this.usePoint = '';
					else if(val > 0) {
						if((val%10) > 0) { 
							if(this.tidCeilUsePoint) {
								clearTimeout(this.tidCeilUsePoint);
								this.tidCeilUsePoint = null;
							}
							this.tidCeilUsePoint = setTimeout(() => {
								this.tidCeilUsePoint = null;
								this.ceilUsePoint();
							}, 2000);
						} else {
							this.usePoint = Math.min(this.usePoint, this.valMoney);
						}
					}
				}
			}
		},
		methods: {
			ceilUsePoint() {
				if(this.usePoint > 0) {
					if((this.usePoint%10) > 0) {
						let val = Math.min(this.usePoint, this.valMoney);
						this.usePoint = Math.floor(val/10)*10;
					} else {
						this.usePoint = Math.min(this.usePoint, this.valMoney);
					}
				}
			},
			clickClose() {
				this.$emit('close-modal')
			},
			clickBuy() {
				if(this.usePoint > 0) {
					this.ceilUsePoint();
				}
				this.$emit('buy-gmo', {usePoint:this.usePoint})
			}
		},
		mounted() {
			this.$store.dispatch('commonStore/pointInfo');
		},
		destroyed() {
			if(this.tidCeilUsePoint) {
				clearTimeout(this.tidCeilUsePoint);
				this.tidCeilUsePoint = null;
			}
		}
	};
</script>

<style lang="scss" scoped>
	#modalgmo {
		position: fixed;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		
		.modalcontent {
			max-width: 320px;
			.description {
				padding-bottom: 16px;
				& > div {
					line-height: 2;
					padding: 0;
					font-size: 16px;
					border-bottom: dotted #888 1px;
					&:nth-child(2) {
						text-align: right;
					}
				}
			}
			.ufpoint {
				margin: 8px 0;
				padding: 8px;
				border: solid 1px #ccc;
				border-radius: 4px;				
			}
			.cmd {
				display: flex;
				margin-top: 32px;
				
				.one {
					& + .one {
						margin-left: 32px;
					}
				}
				button {
					width: 140px;
				}
			}
		}
	}
</style>
